<template>
  <div>
    <section class="orep-header mont" v-if="['pi-application-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../../public/assets/images/mercer-logo.png"  height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png"  height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'spmga'" src="../../../public/assets/images/spmga-logo.svg" class="logo-spmga" alt="Logo">
        <img v-else  src="../../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "pi-application",
    computed: {

      quickQuote() {
        return this.$store.state.quickQuote.quickQuote;
      },
      state() {
        return this.$store.state.quickQuote;
      },
      errorMsg() {
        return this.$store.state.quickQuote.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/pi-application-amba' || first === '/portal/pi-application-amba/' || this.quickQuote.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/pi-application-realshield' || first === '/portal/pi-application-realshield/' || this.quickQuote.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }
        else if (first === '/portal/quick-quote-spmga' || first === '/portal/quick-quote-spmga/' || this.quickQuote.customer.partnerName === 'spmga'){
          return 'spmga';
        }
        else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
